import WithGASetup from '../../components/WithGASetup';
import PreInitialSignupPage from './PreInitialSignupPage.js';

export default WithGASetup(PreInitialSignupPage);
